import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { dataModel } from './ReviewDataModel';
import { RatingsAndReviewsPropTypes } from './RatingsAndReviewsPropTypes';
import { RatingsAndReviewsPlaceholder } from './RatingsAndReviewsPlaceholder';
import { RatingsAndReviewsMobile as RatingsAndReviewsMobileSSR } from './RatingsAndReviewsMobile?clientSideRemove';

const placeholder = (
  <RatingsAndReviewsPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    // For Vite SSR - return the conditionally imported component
    return RatingsAndReviewsMobileSSR;
  },
  client: () => {
    return import('./RatingsAndReviewsMobile');
  },
  placeholder,
  name: 'RatingsAndReviewsMobile'
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'product-section-rr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const RatingsAndReviewsMobileImporter = withErrorBoundary(DynamicComponent);

RatingsAndReviewsMobileImporter.displayName = 'RatingsAndReviewsMobileImporterVite';
RatingsAndReviewsMobileImporter.propTypes = RatingsAndReviewsPropTypes;
RatingsAndReviewsMobileImporter.dataModel = dataModel;